"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    REACH: 'Reach',
    TARGET: 'Target',
    SAFETY: 'Safety',
    HARD: 'Hard',
    'Target Likely': 'Target Likely',
    'Target Reach': 'Target Reach',
};
//# sourceMappingURL=goalType.js.map